import { cssRaw } from 'typestyle';

// Add necessary imports using typestyle

cssRaw(`
    @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:300,700');
`);
